import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import type { DateValidationMessages } from 'shared/utils'

export function useDateValidationMessages(): DateValidationMessages {
  const { t } = useTranslation()

  return useMemo(
    () => ({
      maxFromDateMessage: t('validation.maxFromDateMessage'),
      minToDateMessage: t('validation.minToDateMessage'),
    }),
    [t]
  )
}
